<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Cadastros sem CPF"
            description="Pessoas com cadastro individual na microárea sem CPF"
            url="/gestao-cadastros"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-4291"
            pageIdentifier="cadastros-sem-cpf"
            :enableBadgeModalInformacao="
              Number($store.state.permissoesRaw?.cadastros_sem_cpf_ajuda || 0) >
              0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw?.cadastros_sem_cpf_ajuda || 0
            "
            keyAjudaModalInformacao="cadastros_sem_cpf_ajuda"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'Cadastros sem CPF',
    titleTemplate: null,
  },
  data() {
    return {}
  },
}
</script>

<style></style>
